module.exports = __webpack_public_path__ + "gps/gps-2595cdf0c24673373bee7383b65bba0b.svg";